import {
    type GetMyNotificationsRequestType,
    type GetMyNotificationsResponseType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const GetMyNotifications = async (params?: GetMyNotificationsRequestType): Promise<GetMyNotificationsResponseType> => {
    return await axios(`${SERVER_ADDRESS}/notification/getMyNotifications`, {
        headers: getHeaders(true),
        method: "GET",
        params: params
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};

export default GetMyNotifications;
